/**
 * PwaInstallBanner — authenticated staff-only install nudge.
 *
 * Renders inside AdminShell (spec §3 — private admin area only).
 * Dismissal is remembered for a week so it never nags.
 */
import React from 'react';
import { usePwaInstall } from '../../hooks/usePwaInstall';
import { Button } from '../ui/button';
import { Download, X, Share2 } from 'lucide-react';

const PwaInstallBanner = () => {
  const { showBanner, canPrompt, isIOS, prompt, dismiss } = usePwaInstall();
  if (!showBanner) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-3 right-3 md:bottom-4 md:right-4 z-40 max-w-sm bg-zinc-950 text-white rounded-xl shadow-2xl ring-1 ring-zinc-800 p-4 pr-10"
    >
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss install prompt"
        className="absolute top-2 right-2 w-6 h-6 rounded-md hover:bg-zinc-800 flex items-center justify-center"
        data-testid="pwa-install-dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-[#F56F05] flex items-center justify-center flex-shrink-0">
          <Download className="w-4 h-4 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold">Install Gleam Guru</p>
          {canPrompt ? (
            <p className="text-[12px] text-zinc-300 mt-0.5">
              Put Gleam Guru on your home screen and stay ahead of new leads and jobs.
            </p>
          ) : isIOS ? (
            <p className="text-[12px] text-zinc-300 mt-0.5 flex items-center gap-1 flex-wrap">
              Tap <Share2 className="w-3 h-3 inline" /> then <span className="font-semibold">Add to Home Screen</span>.
            </p>
          ) : null}
          {canPrompt && (
            <Button
              size="sm"
              onClick={prompt}
              className="mt-2 bg-[#F56F05] hover:bg-orange-600 text-white h-8 px-3 text-xs"
              data-testid="pwa-install-btn"
            >
              Install
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PwaInstallBanner;
